import { hasDateStatus, type ReturnCardData } from '@chewy/chat-library-common';
import styles from './OrderCardReturns.module.scss';
import OrderCardReturn from './OrderCardReturn';
import { first } from 'lodash';

interface OrderCardReturnsProps {
  data: ReturnCardData[];
  isSelectable?: boolean;
}

export default function OrderCardReturns({ data, isSelectable = false }: OrderCardReturnsProps) {
  const returns = data;
  const totalReturns = returns.length;
  const firstItem = first(returns);
  const title = firstItem?.title || '';
  const stackDateStatus = returns.some((returnItem) => hasDateStatus(returnItem.dateStatus));

  return (
    <div className={styles.container}>
      <h3 className={styles.orderNumber}>{title}</h3>

      <div className={styles.returnsRow}>
        {returns.map((returnItem, index) => {
          return (
            <OrderCardReturn
              key={returnItem.orderId || index}
              data={[{ ...returnItem, returnNumber: `${index + 1}`, totalReturns }]}
              isSelectable={isSelectable}
              stackDateStatus={stackDateStatus}
            />
          )
        })}
      </div>
    </div>
  );
}
